import type { StoreDetails } from '../model/store.types'
import { useQuery } from '@tanstack/react-query'
import { fetchStoreDetails } from './store.api'
import { storeKeys } from './store.queryKeys'

/**
 * Hook function to fetch store details.
 * Used by component functions.
 */
export function useStoreDetails() {
  return useQuery<StoreDetails, Error, StoreDetails>({
    queryKey: storeKeys.details(),
    queryFn: () => fetchStoreDetails(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 3,
  })
}
